import { Api } from './constants';
import { pipePromise, handleStatuses } from 'utils';

export const fetchDatasets = pipePromise(
  (datasetName, options) => {
    const { pageSize, pageNumber, token, publisherId } = options;

    return fetch(Api.GetDatasetsByName(datasetName, pageSize, pageNumber), {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'x-appinapp-publisherid': publisherId,
      },
    });
  },
  handleStatuses(),
  (response) => response.json()
);

export const createDataset = pipePromise(
  (token, key, publisherId, data) =>
    fetch(Api.CreateDataset('default'), {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'x-appinapp-publisherid': publisherId,
      },
      body: JSON.stringify({
        Key: key,
        Data: data,
      }),
    }),
  handleStatuses(),
  (response) => response.text()
);

export const updateDataset = pipePromise(
  (id, dataset, options) => {
    const { token, publisherId } = options;

    return fetch(Api.UpdateDataset(id), {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${token}`,
        'x-appinapp-publisherid': publisherId,
      },
      body: JSON.stringify({
        Key: dataset.Key,
        TimesUsed: dataset.TimesUsed,
        OrderIds: dataset.OrderIds,
        Data: dataset.Data,
      }),
    });
  },
  handleStatuses(),
  (response) => response.json()
);

export const removeOrder = pipePromise(
  (id, options) => {
    const { token, publisherId } = options;

    return fetch(Api.RemoveOrder(id), {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${token}`,
        'x-appinapp-publisherid': publisherId,
      },
      body: JSON.stringify({
        Comments: 'Cancelled from dashboard',
      }),
    });
  },
  handleStatuses(),
  (response) => response.json()
);
